import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProjects = async () => {
  const res = await axios.get(`${API}/projects`);
  return res.data;
};

export const fetchProject = async (slug) => {
  const res = await axios.get(`${API}/projects/${slug}`);
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await axios.post(`${API}/contact`, payload);
  return res.data;
};

export const fetchTrialPosts = async () => {
  const res = await axios.get(`${API}/ig-posts/trial`);
  return res.data;
};

export const fetchTrialPost = async (shortcode) => {
  const res = await axios.get(`${API}/ig-posts/trial/${shortcode}`);
  return res.data;
};

export const fetchWorkFacets = async () => {
  const res = await axios.get(`${API}/work/facets`);
  return res.data;
};

export const fetchWorkGroups = async (params) => {
  const res = await axios.get(`${API}/work/groups`, { params });
  return res.data;
};

export const fetchWorkPosts = async (params) => {
  const res = await axios.get(`${API}/work`, { params });
  return res.data;
};

export const fetchWorkPost = async (shortcode) => {
  const res = await axios.get(`${API}/work/${shortcode}`);
  return res.data;
};
